import loadScript from 'load-script'

export const LOAD_STRIPE_SCRIPT_REQUEST = "LOAD_STRIPE_SCRIPT_REQUEST";
export const LOAD_STRIPE_SCRIPT_SUCCESS = "LOAD_STRIPE_SCRIPT_SUCCESS";
export const LOAD_STRIPE_SCRIPT_ERROR = "LOAD_STRIPE_SCRIPT_ERROR";


export const loadCheckOutScript = () => {
  return dispatch => {
    dispatch({ type: LOAD_STRIPE_SCRIPT_REQUEST });
    loadScript('https://js.stripe.com/v3/', function (err, script) {
        if (err) {
          dispatch({ type: LOAD_STRIPE_SCRIPT_ERROR });
          return
        } 
        dispatch({ type: LOAD_STRIPE_SCRIPT_SUCCESS });
      })
  };
};



// WEBPACK FOOTER //
// ./state/actions/stripeActions.js